module.exports = __webpack_public_path__ + "b397eb131840fc18bf9c66e86495eab4.png";